function getDefaultState() {
  return {
    selectedId: null,
    contracts: []
  }
}
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    selectedId: null,
    contracts: []
  },
  getters: {
    contracts(state) {
      return state.contracts
    },
    activeKitchens(state) {
      let kitchens = []
      for (const c of state.contracts) {
        if (!c.is_churned) {
          kitchens.push({
            id: c.kitchen_id,
            name: c.kitchen_name
          })
        }
      }
      return kitchens
    },
    contract(state) {
      let dispContracts = state.contracts.filter((contract) => contract.id == state.selectedId)
      if (dispContracts.length == 0) {
        return {
          is_churned: true
        }
      }
      return dispContracts[0]
    }
  },
  mutations: {
    setContracts(state, contracts) {
      state.contracts = contracts
      if (contracts.length > 0) {
        state.selectedId = contracts[0].id
      }
    },
    setContractId(state, id) {
      state.selectedId = id
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getMyContracts({ commit }) {
      await axios
        .get('/contracts')
        .then((response) => {
          commit('setContracts', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    selectContract({ commit }, id) {
      commit('setContractId', id)
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
